export const scrollRestoration = () => {
  if (history.scrollRestoration) {
    // console.log('history.scrollRestoration is supported')
    history.scrollRestoration = 'manual'
  } else {
    // console.log('history.scrollRestoration is not supported')
    window.onbeforeunload = function () {
      window.scrollTo(0, 0);
    }
  }
}
